var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main_container"},[_c('van-nav-bar',{attrs:{"title":_vm.$route.params.name,"left-text":"返回","left-arrow":"","fixed":true},on:{"click-left":_vm.onClickLeft}}),_vm._v(" "),_c('iframe',{staticStyle:{"margin-top":"46px","border":"none"},attrs:{"src":_vm.$route.params.site,"width":"100%","height":"95%"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-301a4f9c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/application/pageIn.vue
// module id = null
// module chunks = 